__turbopack_context__.v({
  "className": "lH85oG_className",
  "variable": "lH85oG_variable",
});
